import React from 'react'
import CatalogSlider from '../../../components/CatalogSlider';

const RomanShades = () => {
    const rollerImages = [
        {
          imgSrc: require('images/roman/drapery-roman.png'),
          headerText: 'Drapery & Roman Shades',
          pdfUrl: require('catalogs/Roman/2025RomanDrapery.pdf')
        },
    ];
    

    return <>
        <CatalogSlider images={rollerImages} headerText="Drapery & Roman Shade Catalogs" shadesId='roman' />;
    </>
}

export default RomanShades